import React, {useContext} from 'react';
import MenuLeft from "./MenuLeft";
import {AppContext} from "../../services";

const MenuLeftWrapper = () => {
    const {companies, currentCompanyId} = useContext(AppContext);
    const company = companies.find(company => company.id === currentCompanyId);
    const showSmsPage: boolean = Boolean(company?.smsSenders?.length);
    const showPaylinksPage: boolean = Boolean(company?.paylinkSenders?.length);
    const showTransactionsGhostPage: boolean = Boolean(company?.enableGhostTransactionsPage);
    const showTransactionsAntigoonPage: boolean = Boolean(company?.enableAntigoonTranactionsPage);

    return (
        <MenuLeft
          smsPage={showSmsPage}
          paylinksPage={showPaylinksPage}
          transactionsGhostPage={showTransactionsGhostPage}
          transactionsAntigoonPage={showTransactionsAntigoonPage}
        />
    );
};

export default MenuLeftWrapper;
